import styled from "styled-components";
import { vegetationAreas } from "../../../../constants/vegetationAreas";

export default function Legend() {
  return (
    <LegendContainer>
      <div className="body">
        {vegetationAreas.map((area) => (
          <div className="item" key={area.id}>
            <div className="text">{area.text}</div>
            <div className="colors">
              <div className="color" style={{ backgroundColor: area.mapColor }}></div>
              <div className="color" style={{ backgroundColor: area.lineColor }}></div>
            </div>
          </div>
        ))}
      </div>
    </LegendContainer>
  );
}

const LegendContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  backdrop-filter: blur(8px);
  background: rgb(238 238 238 / 70%);
  border: 1px solid #f6f8fb;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 4px rgb(50 50 71 / 8%), 0 4px 8px rgb(50 50 71 / 6%);

  .body {
    border-radius: 8px;
    padding: 5px 10px;
    background-color: #f4f4f4;
    border: 0.5px solid #dcdcdc;
    box-shadow: 0 4px 4px rgb(50 50 71 / 8%), 0 4px 8px rgb(50 50 71 / 6%);
  }

  .item {
    display: flex;
    justify-content: space-between;

    &:not(:last-child) {
      margin-bottom: 5px;
    }

    .colors {
      display: flex;
    }

    .color {
      width: 20px;
      height: 20px;
      border-radius: 6px;
      border: 1px solid #b1b1b1;

      &:not(:last-child) {
        margin-right: 5px;
      }
    }
  }
`;
